import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import window from 'global/window';
import Typography from '@digital-hig/mui/dist/Typography';
import Flyout from '@digital-hig/mui/dist/Flyout';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import TextLink from '@mui/material/Link';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import SvgIcon from '@mui/material/SvgIcon';
import SvgCaretUp from '@digital-hig/icon/lib/esm/icons/caret-up';
import SvgCaretDown from '@digital-hig/icon/lib/esm/icons/caret-down';
import Accordion from '@digital-hig/mui/dist/Accordion';
// eslint-disable-next-line import/no-extraneous-dependencies
import AccordionSummary from '@mui/material/AccordionSummary';
// eslint-disable-next-line import/no-extraneous-dependencies
import AccordionDetails from '@mui/material/AccordionDetails';
import { fetchNavData, getNavItems } from '../store/envSlice';
import EnvContext from '../common/envContext';
import {
  ENVIRONMENT, REQUEST_FLAGS, ROUTER_BASENAME, styleVariables,
} from '../common/constants';
import { getEnvironmentConstant } from '../common/utilities';

const GlobalSubNav = ({ isMFE }) => {
  const navData = useSelector(getNavItems);
  const dispatch = useDispatch();
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const { isPreview } = envContext[REQUEST_FLAGS] || false;
  const [open, setOpen] = React.useState({});

  useEffect(() => {
    if (!navData) {
      dispatch(fetchNavData({ env, isPreview, isSSR: false }));
    }
  }, []);

  const handleClose = (id) => {
    const newState = { ...open };
    newState[id] = false;
    setOpen(newState);
  };

  const toggle = (id) => {
    const newState = { ...open };
    newState[id] = !newState[id];
    setOpen(newState);
  };

  const generateLink = (item) => {
    if (!item.linkUrl) {
      return item.text;
    }

    const baseName = getEnvironmentConstant({ key: ROUTER_BASENAME, env });
    if (!isMFE && item.linkUrl.startsWith(baseName)) {
      return <TextLink underline="none" component={Link} to={item.linkUrl.replace(baseName, '')} style={{ color: 'black' }}>{item.text}</TextLink>;
    }

    return <TextLink underline="none" href={item.linkUrl} style={{ color: 'black' }}>{item.text}</TextLink>;
  };

  if (navData) {
    return (
      <RootElement className="maxWidth">
        <Accordion variant="minimal" className="mobileShow">
          <AccordionSummary>
            <Typography variant="headline-smaller">{navData?.text}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {navData?.topNav?.map((topNavItem) => {
              if (topNavItem.flyout) {
                return (

                  <Accordion variant="minimal">
                    <AccordionSummary>
                      <Typography variant="body-copy-small">{topNavItem?.text}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {topNavItem.flyout.map((flyoutItem) => <Typography variant="body-copy-small">{generateLink(flyoutItem)}</Typography>)}
                    </AccordionDetails>
                  </Accordion>
                );
              }
              return <Typography variant="body-copy-small">{generateLink(topNavItem)}</Typography>;
            })}
          </AccordionDetails>
        </Accordion>
        <Typography variant="headline-smaller" className="mobileHide heading">{navData?.text}</Typography>
        <div className="subnavItems mobileHide">
          {navData?.topNav?.map((topNavItem) => {
            const pathName = window?.location?.pathname;
            const trimmedPathName = pathName && pathName.endsWith('/') ? pathName.slice(0, -1) : pathName;
            const trimmedLinkUrl = topNavItem?.linkUrl && topNavItem?.linkUrl.endsWith('/') ? topNavItem?.linkUrl.slice(0, -1) : topNavItem?.linkUrl;
            const isActive = trimmedPathName?.endsWith(trimmedLinkUrl) || (trimmedPathName?.startsWith('/learn/catalog') && trimmedLinkUrl === '/learn/catalog') || false;
            if (topNavItem.flyout) {
              return (
                <ClickAwayListener onClickAway={() => handleClose(topNavItem.id)}>
                  <Flyout
                    className="subNav"
                    onClose={() => handleClose(topNavItem.id)}
                    open={!!open[topNavItem.id]}
                    menuItems={topNavItem.flyout.map((flyoutItem) => {
                      const optStyle = flyoutItem.hasSeparatorAfter ? { borderBottom: '2px solid black' } : {};
                      return { children: <Typography variant="body-copy-small" style={optStyle} class="subNavMenuItem">{generateLink(flyoutItem)}</Typography> };
                    })}
                  >
                    <Typography variant="body-copy-small" style={{ cursor: 'pointer' }}>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,no-script-url */}
                      <TextLink
                        underline="none"
                        href="#"
                        style={{ color: 'black' }}
                        onClick={(e) => {
                          e.preventDefault();
                          toggle(topNavItem.id);
                        }}
                      >
                        {topNavItem?.text}
                        <SvgIcon size="small" style={{ marginBottom: '4px' }}>{open[topNavItem.id] ? <SvgCaretUp /> : <SvgCaretDown />}</SvgIcon>
                      </TextLink>
                    </Typography>
                  </Flyout>
                </ClickAwayListener>
              );
            }
            return <Typography variant="body-copy-small" className={isActive && 'active'}>{generateLink(topNavItem)}</Typography>;
          })}
        </div>

      </RootElement>
    );
  }
  return <span dangerouslySetInnerHTML={{ __html: '<!-- No nav data found -->' }} />;
};

GlobalSubNav.propTypes = {
  isMFE: PropTypes.bool,
};

GlobalSubNav.defaultProps = {
  isMFE: false,
};

const RootElement = styled.div`
  display: flex;
  
  .mobileShow {
    display: none;
    .MuiAccordionSummary-root::after {
      background: transparent !important;
    }
    .MuiAccordionSummary-root::before {
      background: transparent !important;
    }
  }
  .heading {
    padding: 12px 0px;
  }

  .subnavItems {
    display: flex;
    //border-left: 2px solid #000;
    margin-left: 1em;
    align-items: center;

    a, .menu {
      display: block;
      padding: 13px 13px 12px;
      
      &:hover, &:focus {
        text-decoration: none;
        background-color: ${styleVariables.lightDivider};
      }
    }
    
    
    p.active {
      border-bottom: 2px solid black;
      margin-bottom: -1px;
    }
  }

  @media only screen and (max-width: 1040px) {
    .mobileShow {
      display: block;
      width: 100%;
      background-color: transparent;
      margin-bottom: -18px;
      padding: 12px 0;
      &:hover, .MuiAccordion-root   {
        background-color: transparent;
      }
      .MuiAccordionDetails-root {
        .MuiTypography-root {
          margin-bottom:18px;
        }
        padding-bottom: 0px;
      }
      .MuiAccordion-root   {
        .MuiAccordionSummary-content {
          padding-left: 6px
        }
        .MuiAccordionSummary-root {
          flex-direction: row-reverse;
          
          .MuiTypography-root {
            margin-bottom:0px;
          }
          
        }
        .MuiAccordionDetails-root {
          padding: 0px;
          .MuiTypography-root {
            padding-left: 16px;
          }
        }
      }
      
      .MuiAccordionSummary-root {
        padding: 0px 0px 18px;
      }
      
    }
    .mobileHide {
      display: none;
    }
  }
`;

export default React.memo(GlobalSubNav);
